import TagButton from "../common/TagButton";
import heroLeft from "../../assets/offeringsA/heroLeft.svg";
import heroRight from "../../assets/offeringsA/heroRight.svg";
import BackgroundImage from "../../assets/offeringsA/Background.svg";

const HeroSection = ({ children }) => {
  return (
    <div className="relative w-full h-[300px] md:h-[350px] flex justify-center items-center overflow-hidden px-[20px] md:px-0">
      {/* Background image with opacity */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-60 z-0"
        style={{ backgroundImage: `url(${BackgroundImage})` }}
      />

      {/* Foreground content */}
      <div className="flex flex-col md:max-w-full md:w-[48.4375rem] gap-[15px] md:gap-[1.875rem] relative z-10">
        <img
          src={heroLeft}
          alt="hero-image-left"
          className="absolute left-0 md:left-[-25rem] top-[100%] md:translate-y-[-50%] md:top-[50%] z-0 max-w-2/4 md:w-auto opacity-40 md:opacity-100"
        />
        <img
          src={heroRight}
          alt="hero-image-right"
          className="absolute right-0 md:right-[-24rem] bottom-[80%] md:translate-y-[-50%] md:top-[50%] z-0 max-w-2/4 md:w-auto opacity-40 md:opacity-100"
        />
        <TagButton text="Solutions" />
        <div
          className="bg-clip-text text-transparent text-[2rem] md:text-[3.125rem] font-semibold leading-[2.625rem] md:leading-[4.1875rem] font-montserrat inline-block w-fit text-center"
          style={{
            backgroundImage: "linear-gradient(90deg, #000 0%, #0060C7 100%)",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
